+function ($) {
  conditionizr.config({
    assets: '/conditionizr-assets/',
    tests: {
      'ios': ['class'],
      'safari': ['class'],
      'touch': ['class'],
      'chrome': ['class']
    }
  });
}(jQuery);

